<template>
  <div>
    <div
      class="file-upload"
      id="image-file"
      v-on:dragover="preventDefaults"
      v-on:dragenter="preventDefaults"
      v-on:dragleave="preventDefaults"
      v-on:drop="handleFileDropped"
      @click="handleInputClick"
    >
      <div class="file-upload__content dz-clickable">
        <h3 class="title">
          <span class="icon">
            <svg
              width="20px"
              height="23px"
              viewBox="0 0 40 40"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <title>Paper clip icon</title>
              <g
                id="Artboard-Copy-3"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
              >
                <path
                  d="M16.8564912,11.9943544 L16.8564912,31.3100904 C16.8564912,33.0645779 18.3333656,34.4871298 20.1553197,34.4871298 C21.9772739,34.4871298 23.4543582,33.0645779 23.4543582,31.3100904 L23.4543582,5.99707613 C23.4543582,2.68499849 20.6662225,0 17.2271791,0 C13.7879257,0 11,2.68499849 11,5.99707613 L11.4477221,31.8053657 C11.4477221,36.349567 15.2725665,40.033 19.990966,40.033 C24.7089457,40.033 28.534,36.349567 28.534,31.8053657 L28.534,4.37985072"
                  id="Stroke-1"
                  stroke="#000000"
                  stroke-width="2"
                  transform="translate(19.767000, 20.016500) rotate(-315.000000) translate(-19.767000, -20.016500) "
                ></path>
              </g>
            </svg>
          </span>
          <span
            v-html="$t('fileUploadHelpText', {spanOpen: '<span>', spanClose: '</span>', html: '&nbsp;'})"
          ></span>
        </h3>
      </div>
    </div>

    <input
      style="visibility: hidden"
      v-on:change="handleInputChanged"
      id="add-file"
      type="file"
      multiple="true"
    >

    <!-- File List of Uploaded -->
    <div v-if="filesUploaded" class="mt3">
      <ul class="file-upload-list" id="files-list">
        <li
          v-for="(file, idx) in filesUploaded"
          :key="file.name+idx"
          :class="'file-upload-list__item '+file.upload.class"
          :id="file.upload.uuid"
          :data-status="file.upload.status"
        >
          <div class="flex align-center">
            <span class="icon mr2">
              <svg
                width="13px"
                height="13px"
                viewBox="0 0 40 40"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <title>Paper clip icon</title>
                <g
                  id="Artboard-Copy-3"
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <path
                    d="M16.8564912,11.9943544 L16.8564912,31.3100904 C16.8564912,33.0645779 18.3333656,34.4871298 20.1553197,34.4871298 C21.9772739,34.4871298 23.4543582,33.0645779 23.4543582,31.3100904 L23.4543582,5.99707613 C23.4543582,2.68499849 20.6662225,0 17.2271791,0 C13.7879257,0 11,2.68499849 11,5.99707613 L11.4477221,31.8053657 C11.4477221,36.349567 15.2725665,40.033 19.990966,40.033 C24.7089457,40.033 28.534,36.349567 28.534,31.8053657 L28.534,4.37985072"
                    id="Stroke-1"
                    stroke="#000000"
                    stroke-width="2"
                    transform="translate(19.767000, 20.016500) rotate(-315.000000) translate(-19.767000, -20.016500) "
                  ></path>
                </g>
              </svg>
            </span>
            {{file.name + ` ${file.upload.status === 'complete' ? '': `(${file.upload.status})`}`}}
          </div>
          <button type="button" class="btn" @click="handleFileRemoveClick(idx)">
            <div class="icon">
              <svg
                width="7px"
                height="7px"
                viewBox="0 0 40 40"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <g
                  id="Artboard-Copy-4"
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <path
                    d="M6.58079344,6.58079344 L33.08685,33.08685 L6.58079344,6.58079344 Z"
                    id="Line"
                    stroke="#000000"
                    stroke-width="8"
                    stroke-linecap="square"
                    fill-rule="nonzero"
                  ></path>
                  <path
                    d="M6.58079344,6.58079344 L33.08685,33.08685 L6.58079344,6.58079344 Z"
                    id="Line"
                    stroke="#000000"
                    stroke-width="8"
                    stroke-linecap="square"
                    fill-rule="nonzero"
                    transform="translate(19.833822, 19.833822) rotate(-90.000000) translate(-19.833822, -19.833822) "
                  ></path>
                </g>
              </svg>
            </div>
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import 'nuxt-dropzone/dropzone.css';
import { uploadFile, eventBus } from '@/utils/common';

export default {
  components: {},
  mounted() {
    eventBus.$on('requestSuccess', data => {
      this.filesUploaded = [];
    });
  },
  data() {
    return {
      filesUploaded: []
    };
  },
  methods: {
    preventDefaults(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    updateDom() {
      this.$forceUpdate();
    },
    handleFileRemoveClick(index) {
      this.filesUploaded.splice(index, 1);
    },
    handleInputClick() {
      const fileUploadElement = document.getElementById('add-file');
      fileUploadElement.click();
    },
    handleInputChanged() {
      let files = document.getElementById('add-file').files; // file from input
      this.uploadAndDisplayFiles(files);
    },
    handleFileDropped(e) {
      e.preventDefault();
      e.stopPropagation();
      let dt = e.dataTransfer;
      let files = dt.files;
      this.uploadAndDisplayFiles(files);
    },
    uploadAndDisplayFiles(files) {
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        file.upload = { uuid: Date.now() + file.name, status: 'pending', class: 'greyed' };
        if (file.size > 20000000) {
          return alert(`File: ${file.name} is too large`);
        }
        const index = this.filesUploaded.push(file) - 1;
        uploadFile(this.filesUploaded[index])
          .then(response => {
            var element = document.getElementById(this.filesUploaded[index].upload.uuid);
            element.setAttribute('data-token', response.data.upload.token);
            this.filesUploaded[index].upload.status = 'complete';
            this.filesUploaded[index].upload.class = '';
            this.updateDom();
          })
          .catch(error => {
            this.filesUploaded[index].upload.status = 'failed';
            this.filesUploaded[index].upload.class = '';
            this.filesUploaded[index].upload.meta = error;
            this.updateDom();
          });
      }
    }
    // TODO handle upload files.
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
#add-file {
  height: 0px;
  max-height: 0px;
  min-height: 0px;
  padding: 0px;
  margin: 0px;
}
.file-upload {
  cursor: pointer;
  font-size: 12px;
  overflow: hidden;
  position: relative;
  text-align: center;
  border: 1px solid #ddd;
  background: transparent;
  padding: 10px;
  width: 100%;
  height: 44px;
  min-height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;

  .title {
    text-decoration: none;
    font-size: 13px;
    color: #818181;
    font-weight: 400;
    margin: 0;
    position: relative;
    display: flex;
    align-items: center;

    .icon {
      position: absolute;
      right: 105%;
      margin-top: 1px;

      svg path {
        stroke: #818181;
      }
    }
  }
}

.file-upload .dz-success-mark,
.dz-error-mark,
.dz-remove {
  display: none;
}
.dropzone.dz-clickable * {
  cursor: pointer;
}
#file-upload .dz-default {
  display: none;
}
#file-upload .dz-preview {
  display: none;
}
// Results remade
.file-upload-list {
  padding: 0;
  margin: 0;
}
.file-upload-list__item {
  border-radius: 3px;
  font-size: 12px;
  margin-top: 10px;
  overflow: hidden;
  padding: 5px;
  position: relative;
  width: 50%;
  color: #333;
  display: flex;
  justify-content: space-between;
  max-width: calc(100% - 30px);
  text-decoration: none;
  text-overflow: ellipsis;
  vertical-align: middle;
  white-space: nowrap;
  align-items: center;

  .icon {
    path {
      stroke: #888;
    }
  }
  &:hover {
    background: #f2f2f2;
  }

  .btn {
    -webkit-appearance: none;
    border: 0;
    background: transparent;
    color: #888;
    cursor: pointer;
    font-weight: bold;

    .icon {
      svg path {
        stroke: #888;
      }
      &:hover {
        svg path {
          stroke: #222;
        }
      }
    }
  }
}

#image-file,
[type='file'] {
  font-size: 12px;
  overflow: hidden;
  position: relative;
  text-align: center;
  border: 1px solid #ddd;
  color: #3bb4ef;
  background: transparent;
  padding: 10px;
  width: 100%;
  height: 45px;
}

@media (min-width: 1023px) {
  div#image-file.file-upload {
    width: 100%;
  }
}

@media (max-width: 1023px) {
  div#image-file.file-upload {
    width: 100%;
  }
}

.greyed {
  color: lightgrey;
}

.errored {
  color: red;
}
div.flex.align-center {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
}
*{
  font-family: 'Source Sans Pro',Arial, Helvetica, sans-serif!important;
  color:#fff!important;
}

html, body {
  background-color: #fbfbfb;
}

a {
  color: #F04682!important;
}

a:hover {
  border-color: #F04682!important;
}

.header {
  padding: 0 30px 30px 30px;
  background-color: #101218;
  margin-bottom:50px!important;
}

.sidebar .icon .polygon{
  fill: #F04682!important;
}
.sidebar a { color:#F04682!important;}
.sidebar span { color:#F04682!important;}
.input-group--search{
  background-color: transparent!important;
}


.input-group--search .input {
  border-radius: 5px;
  background-color: #ffffff;
  color:#101218!important;
  border: 1px solid rgba($color: #ffffff, $alpha: 0.1)!important;
  padding-left: 45px!important;
}

.input-group--search .input::placeholder { color: rgba($color: #101218, $alpha: 0.5)!important;}
.autocomplete-results {background-color: #31343E!important; border-color: rgba($color: #ffffff, $alpha: 0.1)!important;}

.input-group--search .icon {
  background-color: transparent!important;
  float: left!important;
  display: inline-block;
  left:1rem!important;
  top: 66%!important;
}

.category-boxes__item__link {
  background-color: #ffffff;
  color:#101218!important;
}
.category-boxes__item__link a, .category-boxes__item__link h3, .category-boxes__item__link p {
  color:#101218!important;
}

.category-boxes__item__link p { font-weight: 500;}

.category-boxes__item__link:hover {
  background-color:#fff!important;
  color:#101218!important;
}

.category-boxes__item__link:hover * {
  color:#101218!important;
}

h1.stage__title {
  text-transform: none!important;
}

.category-boxes__item__link .icon polygon, .category-boxes__item__link .icon path {
  fill: #F04682!important;
}

.footer__header {
  background-color: #ecece8!important;
  color: #101218!important;
  border : none!important;
}
.footer__header p { color:#101218!important;}

.footer__item__link {
  border-radius: 5px!important;
  border: 1px solid #ddddd9!important;
  background-color:#ffffff!important;
  color:#101218!important;
}

.footer__item__link h4 {
  color:#101218!important;
}

.footer__item__modals, .footer__item__modals h2{
  color:#101218!important;
}

.footer__modal-option::after {
  color:#F04682!important;
}

.footer__modal-link-text {
  background-color: #F04682!important;
}

.footer__modal-title{
  color: #101218!important;
}

.footer { margin-top: 140px!important;}



.language-dropdown__list .text, .language-dropdown__list .link { color:#101218!important; }

.ma0 { font-weight: 700; }
.stage__text .link { font-weight: 600;}

.content__main { padding:20px!important; border-radius: 5px; background-color: #ffffff; color:#101218!important; border: 1px solid #eeeeee;}
.articles .title { color:#101218!important; }
.content__main h1 { color:#101218!important; }
.article-body, .article-body * { color:#101218!important; font-weight: 600;}
.content__aside .sidebar__links { background-color: #fff; border: 1px solid #eeeeee; border-radius: 5px; position: relative; top:-50px;}
.footer__modal-option a { font-weight: 600!important;}
.footer__modal-link { border-radius: 5px; }

// Contact page,  Links in articles
.article-body, .article-body a { color:#F04682!important;}


.row-container * { color:#101218!important}
.row-container a { color:#F04682!important}
.stage__text .stage__text__question { color:#fff!important; }
.input-group--btns { margin: 5px 0 20px!important; padding:0!important}
.input-group--btns button {background-color: #F04682!important; color:#fff!important; font-weight: 600!important;}

</style>
